import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { CLINIC } from "@/data/site";
import { trackEvent } from "@/lib/analytics";
import { doCall } from "@/lib/actions";

export const AppointmentCTA = ({ title = "Ready to be heard?", subtitle = "Begin with an unhurried consultation. We'll listen carefully, explain your options honestly, and plan care that protects your long-term oral health." }) => (
  <section className="py-16 lg:py-24">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-[var(--cdt-radius-lg)] bg-[var(--cdt-primary)] px-8 py-14 lg:px-16 lg:py-20 text-center">
          <div className="absolute inset-0 opacity-30" style={{ background: "radial-gradient(600px 300px at 80% 0%, rgba(200,168,107,0.35), transparent 60%)" }} />
          <div className="relative">
            <h2 className="font-display text-3xl md:text-4xl text-white leading-tight">{title}</h2>
            <p className="mt-4 text-white/80 max-w-2xl mx-auto leading-8">{subtitle}</p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
              <Link to="/appointment" onClick={() => trackEvent("appointment_cta_click", { location: "cta_section" })} data-testid="cta-appointment-button" className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-[var(--cdt-radius-sm)] bg-white text-[var(--cdt-primary-2)] font-semibold hover:bg-[var(--cdt-surface-2)] transition-colors">
                Request Appointment <ArrowRight className="h-4 w-4" />
              </Link>
              <button onClick={() => doCall(CLINIC.phoneHref, "cta_section")} data-testid="cta-call-button" className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-[var(--cdt-radius-sm)] border border-white/40 text-white font-semibold hover:bg-white/10 transition-colors">
                <Phone className="h-4 w-4" /> Call Us
              </button>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
